import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArticleIcon from "@mui/icons-material/Article";
import HomeIcon from "@mui/icons-material/Home";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import BarChartIcon from "@mui/icons-material/BarChart";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../LoginPage.js/UserAuthContext";

export default function SideBar() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const menuItems = [
    {
      text: "Landed Cost benchmarking",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M11.5 6.09812V5.75C11.5 4.1825 9.13562 3 6 3C2.86438 3 0.5 4.1825 0.5 5.75V8.25C0.5 9.55562 2.14062 10.5931 4.5 10.9038V11.25C4.5 12.8175 6.86438 14 10 14C13.1356 14 15.5 12.8175 15.5 11.25V8.75C15.5 7.45625 13.9113 6.4175 11.5 6.09812ZM14.5 8.75C14.5 9.57625 12.5756 10.5 10 10.5C9.76688 10.5 9.53562 10.4919 9.3075 10.4769C10.6556 9.98563 11.5 9.1875 11.5 8.25V7.10875C13.3669 7.38687 14.5 8.14188 14.5 8.75ZM4.5 9.89062V8.40375C4.99736 8.46856 5.49843 8.50071 6 8.5C6.50157 8.50071 7.00264 8.46856 7.5 8.40375V9.89062C7.00338 9.96399 6.50201 10.0005 6 10C5.49799 10.0005 4.99662 9.96399 4.5 9.89062ZM10.5 7.37063V8.25C10.5 8.77437 9.72437 9.3375 8.5 9.67937V8.21875C9.30688 8.02313 9.99 7.73187 10.5 7.37063ZM6 4C8.57562 4 10.5 4.92375 10.5 5.75C10.5 6.57625 8.57562 7.5 6 7.5C3.42438 7.5 1.5 6.57625 1.5 5.75C1.5 4.92375 3.42438 4 6 4ZM1.5 8.25V7.37063C2.01 7.73187 2.69313 8.02313 3.5 8.21875V9.67937C2.27562 9.3375 1.5 8.77437 1.5 8.25ZM5.5 11.25V10.9894C5.66437 10.9956 5.83063 11 6 11C6.2425 11 6.47937 10.9919 6.71187 10.9781C6.97016 11.0706 7.23325 11.149 7.5 11.2131V12.6794C6.27563 12.3375 5.5 11.7744 5.5 11.25ZM8.5 12.8906V11.4C8.9972 11.4668 9.49833 11.5002 10 11.5C10.5016 11.5007 11.0026 11.4686 11.5 11.4038V12.8906C10.5053 13.0365 9.49468 13.0365 8.5 12.8906ZM12.5 12.6794V11.2188C13.3069 11.0231 13.99 10.7319 14.5 10.3706V11.25C14.5 11.7744 13.7244 12.3375 12.5 12.6794Z"
            fill="white"
          />
        </svg>
      ),
      route: "/detail-view",
    },
    {
      text: "Tariff Matrix",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M11.5 6.09812V5.75C11.5 4.1825 9.13562 3 6 3C2.86438 3 0.5 4.1825 0.5 5.75V8.25C0.5 9.55562 2.14062 10.5931 4.5 10.9038V11.25C4.5 12.8175 6.86438 14 10 14C13.1356 14 15.5 12.8175 15.5 11.25V8.75C15.5 7.45625 13.9113 6.4175 11.5 6.09812ZM14.5 8.75C14.5 9.57625 12.5756 10.5 10 10.5C9.76688 10.5 9.53562 10.4919 9.3075 10.4769C10.6556 9.98563 11.5 9.1875 11.5 8.25V7.10875C13.3669 7.38687 14.5 8.14188 14.5 8.75ZM4.5 9.89062V8.40375C4.99736 8.46856 5.49843 8.50071 6 8.5C6.50157 8.50071 7.00264 8.46856 7.5 8.40375V9.89062C7.00338 9.96399 6.50201 10.0005 6 10C5.49799 10.0005 4.99662 9.96399 4.5 9.89062ZM10.5 7.37063V8.25C10.5 8.77437 9.72437 9.3375 8.5 9.67937V8.21875C9.30688 8.02313 9.99 7.73187 10.5 7.37063ZM6 4C8.57562 4 10.5 4.92375 10.5 5.75C10.5 6.57625 8.57562 7.5 6 7.5C3.42438 7.5 1.5 6.57625 1.5 5.75C1.5 4.92375 3.42438 4 6 4ZM1.5 8.25V7.37063C2.01 7.73187 2.69313 8.02313 3.5 8.21875V9.67937C2.27562 9.3375 1.5 8.77437 1.5 8.25ZM5.5 11.25V10.9894C5.66437 10.9956 5.83063 11 6 11C6.2425 11 6.47937 10.9919 6.71187 10.9781C6.97016 11.0706 7.23325 11.149 7.5 11.2131V12.6794C6.27563 12.3375 5.5 11.7744 5.5 11.25ZM8.5 12.8906V11.4C8.9972 11.4668 9.49833 11.5002 10 11.5C10.5016 11.5007 11.0026 11.4686 11.5 11.4038V12.8906C10.5053 13.0365 9.49468 13.0365 8.5 12.8906ZM12.5 12.6794V11.2188C13.3069 11.0231 13.99 10.7319 14.5 10.3706V11.25C14.5 11.7744 13.7244 12.3375 12.5 12.6794Z"
            fill="white"
          />
        </svg>
      ),
      route: "/tariff-matrix",
    },
    {
      text: "My Dashboard",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M13.98 4.63439L8.48 1.62501C8.33305 1.54381 8.16789 1.50122 8 1.50122C7.83211 1.50122 7.66695 1.54381 7.52 1.62501L2.02 4.63564C1.86293 4.72158 1.73181 4.84811 1.64034 5.00203C1.54888 5.15594 1.50041 5.33159 1.5 5.51064V11.4881C1.50041 11.6672 1.54888 11.8428 1.64034 11.9967C1.73181 12.1507 1.86293 12.2772 2.02 12.3631L7.52 15.3738C7.66695 15.455 7.83211 15.4976 8 15.4976C8.16789 15.4976 8.33305 15.455 8.48 15.3738L13.98 12.3631C14.1371 12.2772 14.2682 12.1507 14.3597 11.9967C14.4511 11.8428 14.4996 11.6672 14.5 11.4881V5.51126C14.4999 5.3319 14.4516 5.15586 14.3601 5.00158C14.2686 4.84731 14.1373 4.72048 13.98 4.63439ZM8 2.50001L13.0212 5.25001L8 8.00001L2.97875 5.25001L8 2.50001ZM2.5 6.12501L7.5 8.86126V14.2231L2.5 11.4888V6.12501ZM8.5 14.2231V8.86376L13.5 6.12501V11.4863L8.5 14.2231Z"
            fill="white"
          />
        </svg>
      ),
      route: "/bookmark-data",
    },
    {
      text: "Analytics",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M14.5 13.5C14.5 13.6326 14.4473 13.7598 14.3536 13.8536C14.2598 13.9473 14.1326 14 14 14H2C1.86739 14 1.74021 13.9473 1.64645 13.8536C1.55268 13.7598 1.5 13.6326 1.5 13.5V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3C2.13261 3 2.25979 3.05268 2.35355 3.14645C2.44732 3.24021 2.5 3.36739 2.5 3.5V9.39812L5.67063 6.625C5.7569 6.54947 5.86652 6.5059 5.9811 6.50157C6.09569 6.49725 6.20828 6.53244 6.3 6.60125L9.97563 9.35812L13.6706 6.125C13.7191 6.07704 13.7768 6.0395 13.8403 6.01467C13.9038 5.98985 13.9717 5.97827 14.0398 5.98065C14.1079 5.98303 14.1749 5.99931 14.2365 6.0285C14.2981 6.05769 14.3531 6.09917 14.398 6.15038C14.443 6.2016 14.4771 6.26148 14.4981 6.32633C14.5191 6.39119 14.5266 6.45965 14.5202 6.52752C14.5137 6.59538 14.4935 6.66122 14.4607 6.72097C14.4279 6.78073 14.3832 6.83314 14.3294 6.875L10.3294 10.375C10.2431 10.4505 10.1335 10.4941 10.0189 10.4984C9.90431 10.5028 9.79173 10.4676 9.7 10.3988L6.02438 7.64313L2.5 10.7269V13H14C14.1326 13 14.2598 13.0527 14.3536 13.1464C14.4473 13.2402 14.5 13.3674 14.5 13.5Z"
            fill="white"
          />
        </svg>
      ),
      route: "/analytics",
    },
    {
      text: "Assumption and Methodology",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M13 2H4.5C3.96957 2 3.46086 2.21071 3.08579 2.58579C2.71071 2.96086 2.5 3.46957 2.5 4V14.5C2.5 14.6326 2.55268 14.7598 2.64645 14.8536C2.74021 14.9473 2.86739 15 3 15H12C12.1326 15 12.2598 14.9473 12.3536 14.8536C12.4473 14.7598 12.5 14.6326 12.5 14.5C12.5 14.3674 12.4473 14.2402 12.3536 14.1464C12.2598 14.0527 12.1326 14 12 14H3.5C3.5 13.7348 3.60536 13.4804 3.79289 13.2929C3.98043 13.1054 4.23478 13 4.5 13H13C13.1326 13 13.2598 12.9473 13.3536 12.8536C13.4473 12.7598 13.5 12.6326 13.5 12.5V2.5C13.5 2.36739 13.4473 2.24021 13.3536 2.14645C13.2598 2.05268 13.1326 2 13 2ZM12.5 12H4.5C4.14884 11.9995 3.80382 12.092 3.5 12.2681V4C3.5 3.73478 3.60536 3.48043 3.79289 3.29289C3.98043 3.10536 4.23478 3 4.5 3H12.5V12Z"
            fill="white"
          />
        </svg>
      ),
      route: "/assumption&methodology",
    },

    {
      text: "News & Latest Developments (Coming soon)",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M5.5 7.5C5.5 7.36739 5.55268 7.24021 5.64645 7.14645C5.74021 7.05268 5.86739 7 6 7H11C11.1326 7 11.2598 7.05268 11.3536 7.14645C11.4473 7.24021 11.5 7.36739 11.5 7.5C11.5 7.63261 11.4473 7.75979 11.3536 7.85355C11.2598 7.94732 11.1326 8 11 8H6C5.86739 8 5.74021 7.94732 5.64645 7.85355C5.55268 7.75979 5.5 7.63261 5.5 7.5ZM6 10H11C11.1326 10 11.2598 9.94732 11.3536 9.85355C11.4473 9.75979 11.5 9.63261 11.5 9.5C11.5 9.36739 11.4473 9.24021 11.3536 9.14645C11.2598 9.05268 11.1326 9 11 9H6C5.86739 9 5.74021 9.05268 5.64645 9.14645C5.55268 9.24021 5.5 9.36739 5.5 9.5C5.5 9.63261 5.55268 9.75979 5.64645 9.85355C5.74021 9.94732 5.86739 10 6 10ZM14.5 4.5V12C14.5 12.3978 14.342 12.7794 14.0607 13.0607C13.7794 13.342 13.3978 13.5 13 13.5H2C1.60336 13.5 1.22287 13.3429 0.941763 13.0631C0.660655 12.7833 0.501818 12.4035 0.5 12.0069V6C0.5 5.86739 0.552678 5.74021 0.646447 5.64645C0.740215 5.55268 0.867392 5.5 1 5.5C1.13261 5.5 1.25979 5.55268 1.35355 5.64645C1.44732 5.74021 1.5 5.86739 1.5 6V12C1.5 12.1326 1.55268 12.2598 1.64645 12.3536C1.74021 12.4473 1.86739 12.5 2 12.5C2.13261 12.5 2.25979 12.4473 2.35355 12.3536C2.44732 12.2598 2.5 12.1326 2.5 12V4.5C2.5 4.23478 2.60536 3.98043 2.79289 3.79289C2.98043 3.60536 3.23478 3.5 3.5 3.5H13.5C13.7652 3.5 14.0196 3.60536 14.2071 3.79289C14.3946 3.98043 14.5 4.23478 14.5 4.5ZM13.5 4.5H3.5V12C3.50025 12.1703 3.47129 12.3395 3.41438 12.5H13C13.1326 12.5 13.2598 12.4473 13.3536 12.3536C13.4473 12.2598 13.5 12.1326 13.5 12V4.5Z"
            fill="white"
          />
        </svg>
      ),
      route: "",
    },
  ];

  const DrawerList = (
    <Box
      sx={{
        width: 270,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background: "linear-gradient(to bottom, #000000, #2c003e)", // dark gradient
        color: "white",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      {/* Top Menu */}
      <List sx={{ marginTop: "15px" }}>
        {menuItems.map(({ text, icon, route }) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={() => navigate(route)}>
              <ListItemIcon sx={{ color: "white", minWidth: "40px" }}>
                {icon}
              </ListItemIcon>
              <ListItemText
                primary={text}
                primaryTypographyProps={{ fontSize: "13px" }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Logout at Bottom */}
      <Box sx={{ p: 2 }}>
        <ListItem
          disablePadding
          sx={{
            borderRadius: "8px",
            backgroundColor: "rgba(255,255,255,0.05)",
          }}
        >
          <ListItemButton
            onClick={() => {
              logout();
              navigate("/login");
            }}
          >
            <ListItemIcon sx={{ color: "white", minWidth: "40px" }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{ fontSize: "13px" }}
            />
          </ListItemButton>
        </ListItem>
      </Box>
    </Box>
  );

  return (
    <div>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={toggleDrawer(true)}
        edge="start"
        sx={{
          mr: 2,
          display: open ? "none" : "inline-flex",
          color: "black",
        }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
